import {
  TOGGLE_GIFT_CARD,
} from "@actions/account/cart"

import { UPDATE_GIFT_CARD } from "@actions/account/billing"

import { post } from "@api/fetch"

/**
 * Toggle gift card on / off
 *
 * @returns dispatch
 */

export const toggleGiftCard = cardID => dispatch => {
  dispatch({ type: UPDATE_GIFT_CARD, cardID, key: "applying", value: true })
  dispatch(
    post(TOGGLE_GIFT_CARD, "settings/giftcards/toggle", { cardID }, () =>
      dispatch({
        type: UPDATE_GIFT_CARD,
        cardID,
        key: "applying",
        value: false
      })
    )
  )
}